import * as React from 'react';
import { Checkbox, FormControlLabel, Grid, Typography } from '@material-ui/core';
import ServiceItem from './ServiceItem';
import { createStyles, Theme } from '@material-ui/core/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useParams } from 'react-router';
import { RootState } from '../../../../reducers';
import { useDispatch, useSelector } from 'react-redux';
import { ChangeEvent, useEffect, useState } from 'react';
import { getServices } from '../../../../reducers/services';
import translate from 'counterpart';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    scroll: {
      position: 'absolute',
      top: 'calc(48px + 48px + 40px)',
      left: 0,
      right: 0,
      overflowY: 'auto',
      bottom: '88px'
    },
    service: {
      padding: '12px 16px'
    },
    title: {
      marginBottom: '4px'
    },
    titleNoDevice: {
      marginTop: '4px',
      marginBottom: '32px',
      color: 'lightgrey'
    },
    label: {
      alignItems: 'start',
      marginLeft: '-12px',
      marginRight: '12px',
      width: '100%'
    },
    box: {
      marginTop: '-10px'
    }
  })
);

interface Props {
  onSelect?: (services: number[]) => void;
  deviceId: number;
  storeId: number;
}

interface Service {
  id: number;
  name: string;
}

interface StateProps {
  services: Service[];
}

const BookingServiceCheckbox: React.FC<Props> = (props: Props) => {
  const { storeId, deviceId, onSelect } = props;
  const classes = useStyles();
  const [servicesIds, setServicesIds] = useState<number[]>([]);
  const { services } = useSelector<RootState, StateProps>(
    (state: RootState) => ({
      services: state.services.items
    })
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getServices(storeId, deviceId));
  }, [deviceId]);

  const handleSelect = (serviceId: number) => (checked: boolean): void => {
    if (checked) {
      servicesIds.push(serviceId);
    } else {
      const index: number = servicesIds.indexOf(serviceId);
      servicesIds.splice(index, 1);
    }
    if (onSelect) {
      onSelect(servicesIds);
    }
  };

  if(deviceId) {
    return (
      <Grid
        container={true}
        direction={'column'}
      >
        <Typography className={classes.title}>
          {translate('booking.services') + ':'}
        </Typography>
        {services?.map((service: Service) => (
          <Grid item={true} key={service.id} className={classes.service}>
            <ServiceItem
              defaultChecked={false}
              service={service}
              onChange={handleSelect(service.id)}
            />
          </Grid>
        ))}
      </Grid>
    )
  } else {
    return (
      <Grid
        container={true}
        direction={'column'}
      >
        <Typography className={classes.title}>
          {translate('booking.services') + ':'}
        </Typography>
        <Typography className={classes.titleNoDevice} color={'primary'}>
          {translate('booking.dialog.noDeviceSelected')}
        </Typography>
      </Grid>
    )
  }

}

export default BookingServiceCheckbox